import { CopyButton, CopyButtonIcon } from "@aircall/blocks";
import { useTranslation } from "react-i18next";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

import { useCall } from "@/hooks/useCall/useCall";

export function SectionCallUuid() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <Section data-test="call-uuid-section">
      <SectionHeader>
        <SectionTitle>{t("call_context.call_uuid")}</SectionTitle>
      </SectionHeader>
      <CopyButton
        value={call.uuid}
        variant="ghost"
        size="sm"
        className="-ml-2 gap-1 self-start font-normal text-muted-foreground"
        data-test="copy-to-clipboard-text"
      >
        {call.uuid}
        <CopyButtonIcon className="size-4" />
      </CopyButton>
    </Section>
  );
}
